import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

interface CalculetteModalContextValue {
  isOpen: boolean;
  openCalculette: () => void;
  closeCalculette: () => void;
}

const CalculetteModalContext = createContext<CalculetteModalContextValue>({
  isOpen: false,
  openCalculette: () => undefined,
  closeCalculette: () => undefined,
});

/**
 * Le parcours « Simulation & Soumission de dossier » est une modale globale :
 * elle s'ouvre par-dessus la page courante depuis le header, sans navigation.
 */
export const CalculetteModalProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openCalculette = useCallback(() => setIsOpen(true), []);
  const closeCalculette = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ isOpen, openCalculette, closeCalculette }),
    [isOpen, openCalculette, closeCalculette],
  );

  return (
    <CalculetteModalContext.Provider value={value}>
      {children}
    </CalculetteModalContext.Provider>
  );
};

export const useCalculetteModal = (): CalculetteModalContextValue =>
  useContext(CalculetteModalContext);
